import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom"
import * as Routes from '../constants/routes'
import HomePage from '../pages/home';
import HsGradPage from '../pages/hs-grad';
import ColGradAnncPage from '../pages/col-grad-annc'
import { AppData } from '../data'

const App = () => {

  return (
    <Router>
          <Switch>
            <Route path={Routes.HOME}>
              {
                window.template === "PRO-CHAMP" && Object.keys(AppData.catalogBrowseData)?.length > 0 && AppData.pageContentData?.length > 0 && <HomePage appData={AppData} />
              }
              {
                window.template === "HS-GRAD" && Object.keys(AppData.catalogBrowseData)?.length > 0 && AppData.pageContentData?.length > 0 && <HsGradPage appData={AppData} />
              }
              {
                window.template === "COL-GRAD-ANNC" && Object.keys(AppData.catalogBrowseData)?.length > 0 && AppData.pageContentData?.length > 0 && <ColGradAnncPage appData={AppData} />
              }
            </Route>
          </Switch>
    </Router>
  )
}

export default App
